import config from "@app/config";
import axios from "axios";

class EditDetailsForm extends HTMLElement {
  async connectedCallback() {
    const form = this.querySelector("[data-form]") as HTMLFormElement;
    const errors = this.querySelector("[data-errors]");

    form?.addEventListener("submit", (e) => {
      e?.preventDefault();
      e?.stopPropagation();

      if (errors) {
        errors.innerHTML = "";
        errors.classList.add("hidden");
      }

      const data = new FormData(form);
      const birthday = data.get("birthday");
      const phone = data.get("phone");

      const postData = {
        id: data.get("id"),
        email: data.get("email"),
        firstName: data.get("firstName"),
        lastName: data.get("lastName"),
        phone: phone ? `phone:${phone}` : null,
        birthday: birthday ? `birthday:${birthday.replace(/-/g, "/")}` : null,
        newsletter: !!data.get("newsletter"),
      };

      // axios.post("http://localhost:8080/updateCustomer", postData, {
      axios
        .post(config.functions.updateCustomer, postData, {
          headers: {
            shop: Shopify.shop.replace(".myshopify.com", ""),
          },
        })
        .then((res) => {
          window.location.reload();
        })
        .catch((e) => {
          if (errors) {
            errors.innerHTML = e.response.data.body;
            errors.classList.remove("hidden");
          }
        });
    });
  }
}

customElements.define("edit-details-form", EditDetailsForm);
